import { Component, Vue } from "vue-facing-decorator";

// Définir les interfaces
export interface MailOptionData {
    text: string; // Le texte à insérer
    newCursorPos: number; // La nouvelle position du curseur après l'insertion
}

export interface MailEditorData {
    [key: string]: string; // Permet d'accéder dynamiquement aux propriétés
}

// Définir un type pour l'éditeur TipTap
export interface TipTapEditor {
    state: {
        selection: {
            from: number;
            to: number;
        };
    };
    getText: () => string;
    getHTML: () => string;
    commands: {
        setContent: (content: string) => void;
        insertContentAt: (position: { from: number; to: number }, content: string) => void;
    };
}

@Component
export class MailEditorMixin extends Vue {
    /**
     * Convertit un texte brut en HTML avec des balises <p>.
     */
    formatTextToHTML(text: string): string {
        const containsParagraph = /<p>.*?<\/p>/.test(text);
        if (!containsParagraph) {
            text = text
                .split("\n")
                .map((line) => `<p>${line.trim() || ""}</p>`)
                .join("");
        }
        return text;
    }

    /**
     * Récupère la position du curseur dans un textarea.
     */
    getTextareaCursorSelection(ref: HTMLInputElement) {
        const textarea = ref;
        return {
            selectionStart: textarea?.selectionStart ? textarea.selectionStart : 0,
            selectionEnd: textarea?.selectionEnd ? textarea.selectionEnd : 0,
        };
    }

    /**
     * Met à jour le contenu d'un textarea avec une nouvelle valeur.
     */
    updateTextareaContentWithMailOption(
        textarea: HTMLInputElement,
        data: MailOptionData,
        modelPropertyName: string,
    ) {
        (this as unknown as MailEditorData)[modelPropertyName] =
            textarea.value.substring(0, this.getTextareaCursorSelection(textarea).selectionStart) +
            data.text +
            textarea.value.substring(this.getTextareaCursorSelection(textarea).selectionEnd);
        textarea.selectionStart = data.newCursorPos;
        textarea.selectionEnd = textarea.selectionStart;
        textarea.focus();
    }

    /**
     * Met à jour le contenu d'un éditeur riche (TipTap) avec une nouvelle valeur.
     */
    updateEditorContentWithMailOption(
        data: MailOptionData,
        editorComponent: { editor: TipTapEditor },
        modelPropertyName: string,
    ) {
        const editor = editorComponent.editor;
        const { from, to } = editor.state.selection;

        // Insérer le contenu à la position du curseur
        editor.commands.insertContentAt({ from, to }, data.text);

        // Mettre à jour le modèle avec le nouveau contenu HTML
        const updatedHTML = editor.getHTML();
        (this as unknown as MailEditorData)[modelPropertyName] = updatedHTML;
    }
}
